import Vue from "vue";
import Chart from "vue2-frappe";

Vue.use(Chart);
